import React, { useState, lazy } from 'react';
import { MainContainer, TopContainerWrapper } from './../Recognition/RecognitionActivity/styles';
import PropTypes from "prop-types";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import LowPerformingGraph from '../common/Analytics/LowPerformingGraph';
import { TabBottomLine, TabWrapper, BorderBottom,ScrollableContainer } from '../RecogntionAdmin/styles';
import { TableBigWidth } from '../common/commonStyles';

const Analytics = ({ getColor }) => {
  const [activeTab, setActiveTab] = useState('Department');
  const [showTopRecogntion, setShowTopRecogntion] = useState(false);
  const [showLocationTopRecogntion, setShowLovationTopRecogntion] = useState(false);

  const topDepartment = () => {
    const dataArray = [
      { name: 'Product', color: '#FFF', value: 70, width: 204, background: '#BE7D9C' },
      { name: 'Quality Assurance', color: '#FFF', value: 40, width: 160, background: '#92A4DA' },
      { name: 'Tech', color: '#FFF', value: 20, width: 96, background: '#75B084' },
    ];
    return (
      <TopDataGraph data={dataArray} heading={'Top Performing Departments'} total={807} totalSubText='Total Challenges' type="challenge"/>
    );
  };

  const topdepartment = [
    { name: 'Product', value1: 70, value2:80, total:150 },
    { name: 'Quality Assurance', value1: 50, value2:80, total:130  },
    { name: 'Tech', value1: 90, value2:50, total:140  },
    { name: 'Sales', value1: 10, value2:40, total:50  },
    { name: 'Marketing', value1: 30, value2:70, total:100  },
    { name: 'HR', value1: 70, value2:40, total:110  },
  ];

  const displayedTopDepartments = showTopRecogntion ? topdepartment : topdepartment.slice(0, 5);

  const toggleShowTopRecognition = () => {
    setShowTopRecogntion(!showTopRecogntion);
  };

  const toggleShowLocationTopRecognition = () => {
    setShowLovationTopRecogntion(!showLocationTopRecogntion);
  };

  const dataDepartment = [
    { category: "Finance", value: 90, color: '#75B084' },
    { category: "Customer Success", value: 60, color: '#DA92C8' },
    { category: "Sales & Marketing", value: 50, color: '#DA6C74' }
  ]

  const dataLocation = [
    { category: "Pune", value: 90, color: '#92A4DA' },
    { category: "New York", value: 60, color: '#BE7D9C' },
    { category: "Paris", value: 50, color: '#DA9B6C' }
  ]

  const DepratmentView = () => 
    (
      <>
        <div className='top-performing'>{topDepartment()}</div>
        <div className='low-performing'><LowPerformingGraph 
          id={`${"test"} ${1}`}
          chartTitle = "Low Performing Departments"
          totalRecognitions = "102"
          data = {dataDepartment}
          chartHeight = {300}
          chartWidth = {300}   
          type="challenge"
          totalText="Total Challenges"
        /></div>
        <div className='top-performing-big' style={{display:"block"}}>
          <TableBigWidth insight>
            <div className="heading">{"Departments' Spotlight on Success"}</div>
            <div className="type">
              <div className="name">Departments</div>
              <div className="value1">Activity Challenges</div>
              <div className="value2">Wellness Challenges</div>
              <div className="value3">Total</div>
            </div>
            <ScrollableContainer
              height={showTopRecogntion ? "380px" : "330px"}
              showAllRows={showTopRecogntion}
            >
              {displayedTopDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="name">{data.name}</div>
                  <div className="value1">{data.value1}</div>
                  <div className="value2">{data.value2}</div>
                  <div className="value3">{data.total}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
           
          </TableBigWidth>

        </div>
      </>
    )

  const topLocations = () => {
    const dataArray = [
      { name: 'Pune', color: '#FFF', value: 70, width: 204, background: '#B1AA56' },
      { name: 'New York', color: '#FFF', value: 40, width: 160, background: '#DA92C8' },
      { name: 'Paris', color: '#FFF', value: 20, width: 96, background: '#DA6C74' },
    ];
    return (
      <TopDataGraph data={dataArray} heading={'Top Performing Locations'} total={807} totalSubText='Total Challenges' type="challenge"  />
    );
  };

  const topLocationsData = [
    { name: 'Pune', value1: 70, value2:80, total:150 },
    { name: 'New York', value1: 50, value2:80, total:130  },
    { name: 'Mumbai', value1: 90, value2:50, total:140  },
    { name: 'Paris', value1: 10, value2:40, total:50  },
    { name: 'England', value1: 30, value2:70, total:100  },
    { name: 'Maxico', value1: 70, value2:40, total:110  },
  ];

  const displayedTopLocations = showTopRecogntion ? topLocationsData : topLocationsData.slice(0, 5);

  const LocationView = () => 
    (
      <>
        <div className='top-performing'>{topLocations()}</div>
        <div className='low-performing'>
          <LowPerformingGraph   
            chartTitle = "Low Performing Locations"
            totalRecognitions = "102"
            data = {dataLocation}
            chartHeight = {300}
            chartWidth = {300}
            id={`${"tesr"} ${1}`}
            type="challenge"
            totalText="Total Challenges"
          />              
        </div>
        <div className='top-performing-big' style={{display:"block"}}>
          <TableBigWidth>
            <div className="heading">{"Locations' Spotlight on Success"}
            </div>
            <div className="type">
              <div className="name">Locations</div>
              <div className="value1">Activity Challenges</div>
              <div className="value2">Wellness Challenges</div>
              <div className="value3">Total</div>
            </div>
            <ScrollableContainer
              height={showLocationTopRecogntion ? "380px" : "330px"}
              showAllRows={showLocationTopRecogntion}
            >
              {displayedTopLocations.map((data, index) => (
                <div className="item" key={index}>
                  <div className="name">{data.name}</div>
                  <div className="value1">{data.value1}</div>
                  <div className="value2">{data.value2}</div>
                  <div className="value3">{data.total}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topLocationsData?.length > 5 && !showLocationTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowLocationTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </TableBigWidth>
        </div>
      </>
    )

  return (
    <MainContainer margin>
      <TopContainerWrapper style={{ flexWrap: "wrap" }}>
        <TabWrapper>
          <TabBottomLine active={activeTab === 'Department'} background={getColor} onClick={() => setActiveTab('Department')}>
            Department
            <BorderBottom active={activeTab === 'Department'} background={getColor} />
          </TabBottomLine>
          <TabBottomLine active={activeTab === 'Location'} background={getColor} onClick={() => setActiveTab('Location')}>
            Location
            <BorderBottom active={activeTab === 'Location'} background={getColor} />
          </TabBottomLine>
          
        </TabWrapper>

        {activeTab === 'Department' ? <DepratmentView /> : null}
        {activeTab === 'Location' ? <LocationView /> : null}

      </TopContainerWrapper> 
    </MainContainer>
  );
};

Analytics.propTypes = {
  getColor: PropTypes.func.isRequired,
};

export default Analytics;